// Best-effort D1 history logging for single-player games, which otherwise
// never touch the network (see hooks/useSinglePlayer.ts). Every call here
// is fire-and-forget with errors swallowed — a Worker that's unreachable
// (offline play, a cold start, whatever) must never affect gameplay.

const PARTYKIT_HOST = import.meta.env.VITE_PARTYKIT_HOST;

function httpBase(): string {
  const isLocal = PARTYKIT_HOST.startsWith('localhost') || PARTYKIT_HOST.startsWith('127.0.0.1');
  return `${isLocal ? 'http' : 'https'}://${PARTYKIT_HOST}`;
}

export async function logSinglePlayerStart(gameId: string, orderType: string, playerName: string): Promise<void> {
  try {
    await fetch(`${httpBase()}/api/log-game-start`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ gameId, orderType, playerName }),
    });
  } catch {
    // offline or Worker unreachable — ignored on purpose
  }
}

export async function logSinglePlayerEnd(gameId: string, playerName: string, score: number): Promise<void> {
  try {
    await fetch(`${httpBase()}/api/log-game-end`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ gameId, playerName, score }),
    });
  } catch {
    // offline or Worker unreachable — ignored on purpose
  }
}
